var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M19.19 19.684H5.77V1h13.42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D253C",
    d: "M8.945 9.267H0v2.976h8.945v2.348l6.717-3.914-6.717-3.852v2.442Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit-icon.267bcd528f22bd099bf1afe0b52cf204.svg";
export { ForwardRef as ReactComponent };